var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.7109,
    cy: 32.3672,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4297 26.2278C18.4297 25.5792 18.6505 24.9498 19.0557 24.4433L22.8565 19.6922C23.6697 18.6757 24.9009 18.084 26.2026 18.084H39.2238C40.5256 18.084 41.7567 18.6757 42.5699 19.6922L46.3707 24.4433C46.7759 24.9498 46.9968 25.5792 46.9968 26.2278V42.366C46.9968 44.7326 45.0783 46.6511 42.7117 46.6511H22.7147C20.3482 46.6511 18.4297 44.7326 18.4297 42.366V26.2278ZM26.2026 20.9407H39.2238C39.6577 20.9407 40.0681 21.1379 40.3392 21.4768L42.8743 24.6456C43.0614 24.8794 42.8948 25.2258 42.5954 25.2258H22.831C22.5316 25.2258 22.3651 24.8794 22.5522 24.6456L25.0873 21.4768C25.3583 21.1379 25.7687 20.9407 26.2026 20.9407ZM34.1444 30.9386C34.1444 30.1497 33.5048 29.5102 32.7161 29.5102C31.9272 29.5102 31.2877 30.1497 31.2877 30.9386V38.2036L30.1523 37.0682C29.5945 36.5105 28.6902 36.5105 28.1323 37.0682C27.5745 37.6262 27.5745 38.5304 28.1323 39.0884L30.696 41.6518C31.8115 42.7675 33.6202 42.7675 34.7359 41.6518L37.2941 39.0938C37.8519 38.5359 37.8519 37.6316 37.2941 37.0737C36.7363 36.5159 35.8319 36.5159 35.2741 37.0737L34.1444 38.2035V30.9386Z",
    fill: "#2995DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/Archived.e93a6bbcc123150c75c6c180aab28958.svg";
export { ForwardRef as ReactComponent };